import { useMutation, useQueryClient } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants";

import {
  CreateTidLinkedAccountParams,
  UseCreateTidLinkedAccountParams,
} from "./types";

export const useCreateTidLinkedAccount = ({
  createTidLinkedAccountFn,
}: UseCreateTidLinkedAccountParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateTidLinkedAccountParams) =>
      createTidLinkedAccountFn(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queries.GET_TID_LINKED_ACCOUNTS],
      });
      queryClient.invalidateQueries({
        queryKey: [queries.GET_ACCOUNTS_LINKABLE_TO_TID],
      });
    },
  });
};
